// extracted by mini-css-extract-plugin
module.exports = {"content":"StoryDeleted_content__2L5Hh"};